import { BoxProps, TextNewProps } from '@jfs/ui-new'

export const styles = {
  boxContainer: {
    ph: 40,
  } as BoxProps,
  rowContainer: {
    flexDirection: 'row',
  } as BoxProps,
  backButtonContainer: {
    paddingRight: 25,
    justify: 'center',
    underlayColor: 'TRANSPARENT',
    align: 'flex-start',
  } as BoxProps,
  headerStyle: {
    fontSize: 18,
    fontFamily: 'jiotype-bold',
    color: 'BLACK_21',
    lineHeight: 28,
  } as TextNewProps,
  header: (isFileContentVisible: boolean) =>
    ({
      padding: 24,
      borderBottomWidth: 1,
      borderColor: 'DISABLED_GREY',
      flexDirection: isFileContentVisible ? 'row' : 'column',
    } as BoxProps),
  centerView: {
    alignSelf: 'center',
    flex: 1,
    width: '100%',
    justify: 'center',
  } as BoxProps,
  mainView: {
    flex: 1,
    width: '100%',
  } as BoxProps,
  tabbarView: {
    position: 'absolute',
    alignSelf: 'center',
    marginLeft: 60,
  } as BoxProps,
}
